import { render, staticRenderFns } from "./question_accept.vue?vue&type=template&id=4494842a"
import script from "./question_accept.vue?vue&type=script&lang=js"
export * from "./question_accept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports